export const buttonType = {
  BACK_BUTTON: 'backButton',
  FORWARD_BUTTON: 'forwardButton',
  START_BUTTON: 'startButton',
  END_BUTTON: 'endButton',
}
